import React from "react";
import { Link } from "react-router-dom";
import SplashFooter from "../common/footer/SplashFooter";
import SplashHeader from "../common/header/SplashHeader";
import SEO from "../common/SEO";
import SplashBanner from "../component/banner/SplashBanner";
import SplashCta from "../component/cta/SplashCta";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import SplashData from "../data/splash/SplashData.json";
import { slugify } from "../utils";
import { FaAngleRight } from "react-icons/fa";

const DemoData = SplashData[0];
const FeatureData = SplashData[1];
const CardsLists = ({ title, subtitle, data, grid }) => {
  return (
    <div
      className="section section-padding bg-color-light spalsh-why-choose"
      id="splash-why-choose"
    >
      <div className="container">
        <div className="section-heading heading-left">
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-7">
              <h2 className="title">{title}</h2>
            </div>
            <div className="col-xl-4 col-lg-5 offset-xl-2">
              <p>{subtitle}</p>
            </div>
          </div>
        </div>
        <div className="row">
          {data &&
            data.length > 0 &&
            data.map((d) => (
              <div
                className={
                  grid ? "col-xl-4 col-lg-6" : "col-12 animated bounceIn"
                }
                key={d.id}
              >
                {/* if d.disabled overlay and prevent click */}

                <div
                  className="support-box online-documentation splash-hover-control"
                  style={{
                    position: "relative",
                    pointerEvents: d.disabled ? "none" : "auto",
                    opacity: d.disabled ? 0.6 : 1,
                    overflow: "hidden",
                  }}
                >
                  {d.disabled && (
                    <div
                      className="overlay"
                      style={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        width: "100%",
                        height: `calc(100% - 30px)`,
                        borderRadius: "20px",
                        backgroundColor: "rgba(0, 0, 0, 0.5)",
                        color: "#fff",
                        paddingBottom: "30px",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 2,
                      }}
                    >
                      <h6 style={{
                        color: "#fff"
                      }}>Deshabilitado</h6>
                    </div>
                  )}
                  <a href={d.href ? d.href : "#"} onClick={d.onClick}>
                    <div className="inner">
                      <div className="content">
                        <div className="heading">
                          <h4
                            className="title"
                            dangerouslySetInnerHTML={{ __html: d.title }}
                          ></h4>
                          {d.icon && (
                            <div className="icon">
                              <img
                                src={process.env.PUBLIC_URL + d.icon}
                                alt="Thumb"
                              />
                            </div>
                          )}
                        </div>
                        {typeof d.para === "string" && (
                          <p dangerouslySetInnerHTML={{ __html: d.para }} />
                        )}
                        {typeof d.para === "object" && (
                          <div className="row">
                            <div className="col-12">{d.para}</div>
                          </div>
                        )}
                      </div>
                      <div className="btn-area">
                        <span className="item-btn">
                          <FaAngleRight />
                        </span>
                      </div>
                    </div>
                  </a>
                </div>
              </div>
            ))}
        </div>
      </div>
      <div className="line-shape">
        <img
          src={process.env.PUBLIC_URL + "/images/others/line-6.png"}
          alt="Line"
        />
      </div>
    </div>
  );
};
export default CardsLists;
